import React, { useState, useEffect } from 'react'

import { Stage } from './../context/LumiContext.types'
import { useLumi } from './../hooks/useLumi'
import * as S from './progressBar.styles'

export const ProgressBar = () => {
    const [percentage, setPercentage] = useState(0)
    const { onChangeStage } = useLumi()

    useEffect(() => {
        const interval = setInterval(() => {
            setPercentage((prev) => {
                if (prev < 100) {
                    return prev + 1
                } else {
                    clearInterval(interval)

                    return prev
                }
            })
        }, 50)

        return () => clearInterval(interval)
    }, [])

    useEffect(() => {
        if (percentage === 100) {
            const timeout = setTimeout(() => {
                onChangeStage(Stage.Completed)
            }, 1000)

            return () => clearTimeout(timeout)
        }
    }, [percentage])

    return (
        <S.ProgressBar>
            <S.BarBackground>
                <S.BarFill style={{ width: `${percentage}%` }}>{Math.round(percentage)}%</S.BarFill>
            </S.BarBackground>

            <S.Info>
                <span>1 min left</span>
            </S.Info>
        </S.ProgressBar>
    )
}
